import React, { Component } from 'react';
import {
  Nav,
  NavContainer,
  MenuIconWrapper,
  GencatIconWrapper,
  GencatIcon,
  GencatWrapper,
  HipermapaTextWrapper,
  HipermapaText,
  DeleteSearchIcon,
  DeleteSearchIconButton,
  SearcherWrapper,
  SearcherInput,
  SearcherContainer,
  TreeSearchButtonWrapper,
  TreeSearchButton,
  CollapsedNav,
  ToolButtonsContainer,
  ToolButtonWrapper,
  ToolButton,
  ToolButtonIcon,
  ToolButtonHref,
  AccesibilityTitleLabel,
  TamanyLletraLabel,
  AccesibilityFontSize,
  ModalAccesibilityContainer,
  ModalAccesibilityForm,
  Switch,
  SwitchCB,
  SwitchSpan,
  FormIcon,
  AccesibilityRow,
  MoreButton,
  MoreButtonIcon,
  SpaceContainer,
  ToolButtonsCollapsedContainer,
  ToolButtonsCollapsedWrapper,
  TBCbtn,
  TBCli,
  TBCul,
  TBCa,
  GraySearchButton,
  SvgSearchButton,
  ToolButtonIconPrint,
  ToolButtonIconShare,
  AjudaModal,
  AjudaModalText,
  InfoButton,
  ToolButtonIconLoad,
  FullScreenButton
} from './NavbarElements';
import { displayComponents } from '../Utils/VisorsUtils';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.css';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { visorVariables } from '../Utils/VisorsUtils';
import { SVGNewTab } from '../Sidebar/SidebarElements';

export class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolAccesibilityBtn: false, //variable del estado del botón de accesibilidad.
      toolShareBtn: false, //variable del estado del botón de compartir.
      toolCommentBtn: false, //variable del estado del botón de comentarios.
      toolQuestionBtn: false, //variable del estado del botón de ayuda.
      busquedaBtn: false, //variable del estado del botón de búsqueda.
      sliderLletra: false, //varible del estado del slider del tamaño de la letra de la accesibilidad.
      sliderContrast: false, //varible del estado del slider del contraste de la accesibilidad.
      toolCollapsedContainer: false, //variable del estado del contenedor de los botones cuando estan contraidos.
      searchText: '',
      modalAjudaOpen: false,
      pdfMenu: false,
      placeHolder: ''
    };
  }

  /**
   * @desc cuando se monta el componente, se inicializa la variable de estado de las propiedades del mapa
   */
  componentDidMount() {
    //funcion encargada de cerrar los modales de accesibilidad una vez la medida de la pantalla se hace grande para evitar problemas de maquetación
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1280)
        this.setState({
          toolCollapsedContainer: false,
          toolAccesibilityBtn: false,
          modalAjudaOpen: false
        });
    });
    let ph = getTranslatedKey('cerca') + ' ';
    let hasComma = false;
    if (displayComponents.cercaLayers) {
      ph += (hasComma ? ', ' : '') + getTranslatedKey('cercaPhLayer');
      hasComma = true;
    }
    if (displayComponents.cercaFeatures) {
      ph += (hasComma ? ', ' : '') + getTranslatedKey('cercaPhFeature');
      hasComma = true;
    }
    if (displayComponents.cercaPlaces) {
      ph += (hasComma ? ', ' : '') + getTranslatedKey('cercaPhPlace');
      hasComma = true;
    }
    this.setState({ placeHolder: ph });
  }

  /**
   * @desc función de estado de limpiar los estados de todos los botones del Nabvar
   */
  newTabGenCat = () => {
    window.open('https://web.gencat.cat/ca/inici/', '_blank');
  };

  /**
   * @desc función de estado al clicar el botón del menú
   */
  onMenuBtnClick = () => {
    this.setState({
      toolShareBtn: false, //variable del estado del botón de compartir
      toolAccesibilityBtn: false, //variable del estado del botón de accesibilidad
      toolCommentBtn: false, //variable del estado del botón de comentarios
      toolQuestionBtn: false, //variable del estado del botón de ayuda
      busquedaBtn: false //variable del estado del botón de búsqueda
      // searchText: '' //variable del estado del texto de buscador
    });
    this.props.toggleMenuLateral();
    this.props.closeInfo();
  };

  /**
   * @desc función de estado al presionar Enter en la cerca
   */
  onBusquedaKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.onBusquedaBtnClick();
    } else if (e.key === 'Backspace' && (e.target.value.length === 0 || e.target.value === '')) {
      this.onDeleteSearchBtnClick();
    }
  };

  /**
   * @desc función de estado al clicar el botón de búsqueda
   */
  onBusquedaBtnClick = () => {
    this.setState(
      {
        toolShareBtn: false,
        toolAccesibilityBtn: false,
        toolCommentBtn: false,
        toolQuestionBtn: false,
        busquedaBtn: true
      },
      () => {
        this.props.toggleMenuLateral(false);
        this.props.onClickCerca();
      }
    );
  };

  /**
   * @desc función de estado al clicar el botón de búsqueda
   */
  onCercaAvançadaBtnClick = () => {
    this.setState(
      {
        toolShareBtn: false,
        toolAccesibilityBtn: false,
        toolCommentBtn: false,
        toolQuestionBtn: false,
        busquedaBtn: false
      },
      () => {
        this.props.toggleMenuLateral(false);
        this.props.handleCercaAvançadaOpen(!this.props.cercaAvançada);
        this.setState({ searchText: '' });
      }
    );
  };

  /**
   * @desc función de estado al clicar el botón de limpiar la barra de búsqueda
   */
  onDeleteSearchBtnClick = () => {
    this.setState(
      {
        toolShareBtn: false,
        toolAccesibilityBtn: false,
        toolCommentBtn: false,
        toolQuestionBtn: false,
        busquedaBtn: false,
        searchText: ''
      },
      () => {
        this.props.toggleAutoTab(true);
        this.props.toggleMenuLateral(false);
        document.getElementById('inputCerca').value = '';
        document.getElementById('inputCercaCollapsed').value = '';
        this.props.onClickCloseCerca();
      }
    );
  };

  /**
   * @desc función de estado al clicar el botón de compartir
   */
  onShareBtnClick = (to) => {
    this.setState({
      toolShareBtn: !this.state.toolShareBtn,
      toolAccesibilityBtn: false,
      toolCommentBtn: false,
      toolQuestionBtn: false,
      busquedaBtn: false
    });
    this.props.toggleMenuLateral(false);
    this.props.toggleShare(to);
  };

  hasButtons = () => {
    return (
      displayComponents.descarrega ||
      displayComponents.imprimir ||
      displayComponents.compartir ||
      displayComponents.accessibilitat ||
      displayComponents.contact ||
      displayComponents.ajuda ||
      displayComponents.fullScreen
    );
  };

  handleGuia = () => {
    const newTab = window.open(visorVariables.urlManual, '_blank');
    newTab.focus();
  };
  handleFaqs = () => {
    const newTab = window.open(visorVariables.urlFaqs, '_blank');
    newTab.focus();
  };
  handleTutorial = () => {
    const newTab = window.open(visorVariables.urlTutorial, '_blank');
    newTab.focus();
  };

  /**
   * @desc función de estado al clicar el botón de preguntas
   */
  onQuestionBtnClick = () => {
    this.setState({
      toolAccesibilityBtn: false,
      toolCommentBtn: false,
      toolShareBtn: false,
      modalAjudaOpen: false,
      busquedaBtn: false
    });
    if (this.state.toolCollapsedContainer === true) {
      this.setState({
        toolCollapsedContainer: !this.state.toolCollapsedContainer,
        toolAccesibilityBtn: false
      });
    }
    this.props.toggleAjuda();
    this.props.toggleMenuLateral(false);
  };

  toggleModalAjuda = () => {
    if (window.innerWidth > 768) {
      this.setState({
        modalAjudaOpen: !this.state.modalAjudaOpen,
        toolQuestionBtn: !this.state.toolQuestionBtn,
        toolAccesibilityBtn: false,
        toolCommentBtn: false,
        toolShareBtn: false,
        busquedaBtn: false
      });
      this.props.toggleShare(null, true);
      this.props.toggleMenuLateral(false);
    } else if (!this.state.modalAjudaOpen) {
      this.toggleShare('help');
    } else {
      this.setState({ modalAjudaOpen: false });
    }
  };

  /**
   * @desc función de estado al clicar el botón de accesibilidad
   */
  onAccesibilityBtnClick = () => {
    if (window.innerWidth > 768) {
      this.setState({
        toolAccesibilityBtn: !this.state.toolAccesibilityBtn,
        toolCommentBtn: false,
        toolShareBtn: false,
        toolQuestionBtn: false,
        busquedaBtn: false,
        modalAjudaOpen: false
      });
      this.props.toggleShare(null, true);
      this.props.toggleMenuLateral(false);
    } else if (!this.state.toolAccesibilityBtn) {
      this.toggleShare('acces');
    } else {
      this.setState({ toolAccesibilityBtn: false });
    }
  };
  /**
   *
   * @desc función de estado al clicar el slider de tamaño de la letra o contraste
   */
  onAccesibilitySliderClick = (event) => {
    switch (event) {
      case 'lletra':
        this.props.toggleFontSize();
        this.setState({ sliderLletra: !this.state.sliderLletra });
        break;
      case 'contrast':
        this.setState({ sliderContrast: !this.state.sliderContrast });
        break;
      default:
        break;
    }
  };

  /**
   * @desc función de estado al clicar el botón de tres puntos
   */
  onClickMoreBtn = () => {
    this.setState({
      toolCollapsedContainer: !this.state.toolCollapsedContainer,
      toolAccesibilityBtn: false,
      modalAjudaOpen: false
    });
  };

  handleSearch = (e) => {
    this.setState({ searchText: e.target.value });
    if (e.target.value.length >= 3) {
      this.props.onClickCerca();
    }
    if (e.target.value.length === 0 || e.target.value === '') {
      this.props.toggleAutoTab(true);
      this.onDeleteSearchBtnClick();
    }
  };

  toggleShare = (arg) => {
    this.props.toggleShare(arg);
    this.setState({ toolAccesibilityBtn: false });
    if (this.state.toolCollapsedContainer) {
      this.setState({ toolCollapsedContainer: false });
    }
  };

  fullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  render() {
    return (
      <>
        <Nav id="nav-bar" windowWidth={this.props.windowWidth}>
          <NavContainer id="nav-bar-container">
            {displayComponents.sidebar && (
              <MenuIconWrapper
                title={getTranslatedKey('menuPrincipal')}
                onClick={() => this.onMenuBtnClick()}
                selected={this.props.isOpen}
                aria-label={getTranslatedKey('aria_menuPrincipalBtn')}
                className={`${!this.props.isOpen ? 'menu-principal' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" viewBox="0 0 384 384" fill={this.props.isOpen ? '#000' : '#fff'}>
                  <g>
                    <g>
                      <g>
                        <rect x="0" y="277.333" width="384" height="42.667" />
                        <rect x="0" y="170.667" width="384" height="42.667" />
                        <rect x="0" y="64" width="384" height="42.667" />
                      </g>
                    </g>
                  </g>
                </svg>
              </MenuIconWrapper>
            )}
            <GencatWrapper id="GencatWrapper">
              <GencatIconWrapper>
                <GencatIcon onClick={() => this.newTabGenCat()} src={this.props.navbarObj.gencatIcon} alt={getTranslatedKey('altGencatIcon')} />
              </GencatIconWrapper>
              <HipermapaTextWrapper>
                <HipermapaText title={visorVariables.name} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {visorVariables.name}
                </HipermapaText>
              </HipermapaTextWrapper>
            </GencatWrapper>
            {displayComponents.cerca && (
              <SearcherContainer id="SearcherContainer">
                {displayComponents.infoCerca && (
                  <InfoButton title={getTranslatedKey('searchInfo')} onClick={() => this.toggleShare('info')}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" width="20" fill="white" viewBox="0 0 512 512">
                      <g>
                        <g>
                          <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256    C512,114.511,397.504,0,256,0z M282.289,357.621c0,8.088-11.794,16.174-26.284,16.174c-15.164,0-25.946-8.086-25.946-16.174    V229.234c0-9.435,10.783-15.839,25.946-15.839c14.49,0,26.284,6.404,26.284,15.839V357.621z M256.006,182.396    c-15.501,0-27.631-11.457-27.631-24.263c0-12.805,12.131-23.925,27.631-23.925c15.164,0,27.296,11.12,27.296,23.925    C283.302,170.939,271.169,182.396,256.006,182.396z" />
                        </g>
                      </g>
                    </svg>
                  </InfoButton>
                )}
                <SearcherWrapper className="input-group">
                  <GraySearchButton title={getTranslatedKey('cerca')} onClick={() => this.onBusquedaBtnClick()}>
                    <FaSearch
                      style={{
                        verticalAlign: 'middle',
                        transform: 'translate(0px, -2px)'
                      }}
                    />
                  </GraySearchButton>
                  <SearcherInput
                    type="text"
                    className="form-control"
                    aria-describedby="basic-addon1"
                    placeholder={this.state.placeHolder}
                    onChange={(e) => this.handleSearch(e)}
                    onKeyDown={(e) => this.onBusquedaKeyDown(e)}
                    onFocus={(e) => this.handleSearch(e)}
                    id="inputCerca"
                    value={this.state.searchText}
                    title={getTranslatedKey('cerca')}
                    fontSizeEnabled={this.props.fontSizeEnabled}
                  />
                  {this.state.searchText.length > 0 && (
                    <DeleteSearchIconButton title={getTranslatedKey('esborra')} onClick={() => this.onDeleteSearchBtnClick()}>
                      <DeleteSearchIcon alt={getTranslatedKey('altDeleteIcon')} title={getTranslatedKey('esborrarCerca')}>
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                        />
                      </DeleteSearchIcon>
                    </DeleteSearchIconButton>
                  )}
                </SearcherWrapper>
                {displayComponents.cercaAvançada && (
                  <TreeSearchButtonWrapper>
                    <TreeSearchButton
                      id="CercaBtn"
                      selected={this.props.cercaAvançada}
                      onClick={() => this.onCercaAvançadaBtnClick()}
                      title={getTranslatedKey('cercaAvançada')}>
                      <SvgSearchButton version="1.1" width="24" height="24" viewBox="0 0 24 24" selected={this.props.cercaAvançada}>
                        <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                      </SvgSearchButton>
                    </TreeSearchButton>
                  </TreeSearchButtonWrapper>
                )}
              </SearcherContainer>
            )}
            <SpaceContainer />
            <ToolButtonsContainer id="tool-buttons-container">
              {displayComponents.descarrega && (
                <ToolButtonWrapper>
                  <ToolButton
                    title={this.props.user?.user && this.props.intranet ? getTranslatedKey('gestion') : getTranslatedKey('titleNoUser')}
                    selected={this.props.modalShareOpen && this.props.modalShareKind === 'download'}
                    onClick={() => this.toggleShare('download')}
                    aria-label={getTranslatedKey('aria_accessibilitatBtn')}>
                    <ToolButtonIconLoad
                      selected={this.props.modalShareOpen && this.props.modalShareKind === 'download'}
                      alt={getTranslatedKey('altAccesibilityIcon')}>
                      <g>
                        <path d="M152.9,13.9c-12.2-13.2-32.8-14-46-1.8c-0.6,0.6-1.2,1.2-1.8,1.8L10.6,124.2c-11.3,13.2-9.8,33.1,3.4,44.4   c13.2,11.3,33.1,9.8,44.4-3.4l39.1-45.6v292.8c0,17.4,14.1,31.5,31.5,31.5s31.5-14.1,31.5-31.5V119.6l39.1,45.6   c11.3,13.2,31.2,14.7,44.4,3.4s14.7-31.2,3.4-44.4L152.9,13.9z" />
                        <path d="M496,341.2c-13.2-11.3-33.1-9.8-44.4,3.4l-39.1,45.6V97.4c0-17.4-14.1-31.5-31.5-31.5c-17.4,0-31.5,14.1-31.5,31.5v292.8   l-39.1-45.6c-11.3-13.2-31.2-14.7-44.4-3.4c-13.2,11.3-14.7,31.2-3.4,44.4l0,0l94.5,110.2c11.3,13.2,31.2,14.7,44.4,3.4   c1.2-1,2.4-2.2,3.4-3.4l94.5-110.2C510.7,372.4,509.2,352.6,496,341.2z" />
                      </g>
                    </ToolButtonIconLoad>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
              {displayComponents.imprimir && (
                <ToolButtonWrapper>
                  <ToolButton
                    title={getTranslatedKey('print')}
                    selected={this.props.modalShareOpen && this.props.modalShareKind === 'print'}
                    onClick={() => this.toggleShare('print')}
                    aria-label={getTranslatedKey('print')}>
                    <ToolButtonIconPrint
                      selected={this.props.modalShareOpen && this.props.modalShareKind === 'print'}
                      alt={getTranslatedKey('altQuestionIcon')}>
                      <g>
                        <path d="M230.559,62.498h-27.785V17.133c0-4.143-3.358-7.5-7.5-7.5H52.785c-4.142,0-7.5,3.357-7.5,7.5v45.365H17.5   c-9.649,0-17.5,7.85-17.5,17.5v96.225c0,9.649,7.851,17.5,17.5,17.5h27.785v37.203c0,4.143,3.358,7.5,7.5,7.5h142.488   c4.142,0,7.5-3.357,7.5-7.5v-37.203h27.785c9.649,0,17.5-7.851,17.5-17.5V79.998C248.059,70.349,240.208,62.498,230.559,62.498z    M60.285,24.633h127.488v37.865H60.285V24.633z M187.773,223.426H60.285v-74.404h127.488V223.426z M233.059,176.223   c0,1.355-1.145,2.5-2.5,2.5h-27.785v-37.201c0-4.143-3.358-7.5-7.5-7.5H52.785c-4.142,0-7.5,3.357-7.5,7.5v37.201H17.5   c-1.355,0-2.5-1.145-2.5-2.5V79.998c0-1.356,1.145-2.5,2.5-2.5h35.285h142.488h35.285c1.355,0,2.5,1.144,2.5,2.5V176.223z" />
                        <circle cx="195.273" cy="105.76" r="10.668" />
                        <path d="M158.151,163.822H89.907c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h68.244c4.142,0,7.5-3.357,7.5-7.5   C165.651,167.18,162.294,163.822,158.151,163.822z" />
                        <path d="M158.151,193.623H89.907c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h68.244c4.142,0,7.5-3.357,7.5-7.5   C165.651,196.98,162.294,193.623,158.151,193.623z" />
                      </g>
                    </ToolButtonIconPrint>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
              {displayComponents.compartir && (
                <ToolButtonWrapper>
                  <ToolButton
                    title={getTranslatedKey('share')}
                    selected={this.props.modalShareOpen && this.props.modalShareKind === 'share'}
                    onClick={() => this.toggleShare('share')}
                    aria-label={getTranslatedKey('aria_compartirBtn')}>
                    <ToolButtonIconShare selected={this.props.modalShareOpen && this.props.modalShareKind === 'share'}>
                      <path d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" />
                    </ToolButtonIconShare>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
              {displayComponents.accessibilitat && (
                <ToolButtonWrapper>
                  <ToolButton
                    title={getTranslatedKey('accesibility')}
                    selected={this.state.toolAccesibilityBtn}
                    onClick={() => this.onAccesibilityBtnClick()}
                    aria-label={getTranslatedKey('aria_accessibilitatBtn')}>
                    <ToolButtonIcon selected={this.state.toolAccesibilityBtn} alt={getTranslatedKey('altAccesibilityIcon')}>
                      <g xmlns="http://www.w3.org/2000/svg">
                        <path d="m256 112c30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56 25.1 56 56 56z" />
                        <path d="m432 112.8-.5.1-.4.1c-1 .3-2 .6-3 .9-18.6 5.5-108.9 30.9-172.6 30.9-59.1 0-141.3-22-167.6-29.5-2.6-1-5.3-1.9-8-2.6-19-5-32 14.3-32 31.9 0 17.5 15.7 25.8 31.5 31.8v.3l95.2 29.7c9.7 3.7 12.3 7.5 13.6 10.8 4.1 10.6.8 31.6-.3 38.9l-5.8 45-32.1 176.3c-.1.5-.2 1-.3 1.5l-.2 1.3c-2.3 16.1 9.5 31.8 32 31.8 19.6 0 28.3-13.5 32-31.9 0 0 28-157.6 42-157.6s42.8 157.6 42.8 157.6c3.8 18.4 12.4 31.9 32 31.9 22.5 0 34.4-15.7 32-31.9-.2-1.4-.5-2.7-.8-4.1l-32.5-174.7-5.8-45c-4.2-26.2-.8-34.9.3-36.9 0 0 .1-.1.1-.2 1.1-2 6-6.5 17.5-10.8l89.3-31.2c.5-.1 1.1-.3 1.6-.5 16-6 32-14.3 32-31.9s-13-37-32-32z" />
                      </g>
                    </ToolButtonIcon>
                  </ToolButton>
                </ToolButtonWrapper>
              )}

              {displayComponents.contact && (
                <ToolButtonWrapper>
                  <ToolButton title={getTranslatedKey('contact')} aria-label={getTranslatedKey('aria_bustiaContacteBtn')}>
                    <ToolButtonHref href={visorVariables.correuSuggeriment} rel="noreferrer" target="_blank">
                      <ToolButtonIcon alt={getTranslatedKey('altCommentIcon')}>
                        <g xmlns="http://www.w3.org/2000/svg">
                          <path d="M467,61H45C20.218,61,0,81.196,0,106v300c0,24.72,20.128,45,45,45h422c24.72,0,45-20.128,45-45V106    C512,81.28,491.872,61,467,61z M460.786,91L256.954,294.833L51.359,91H460.786z M30,399.788V112.069l144.479,143.24L30,399.788z     M51.213,421l144.57-144.57l50.657,50.222c5.864,5.814,15.327,5.795,21.167-0.046L317,277.213L460.787,421H51.213z M482,399.787    L338.213,256L482,112.212V399.787z" />
                        </g>
                      </ToolButtonIcon>
                    </ToolButtonHref>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
              {displayComponents.ajuda && (
                <ToolButtonWrapper>
                  <ToolButton
                    title={getTranslatedKey('help')}
                    selected={this.state.modalAjudaOpen || this.props.ajudaOpen}
                    onClick={() => this.toggleModalAjuda()}
                    aria-label={getTranslatedKey('aria_ajudaBtn')}>
                    <ToolButtonIcon selected={this.state.modalAjudaOpen || this.props.ajudaOpen} alt={getTranslatedKey('altQuestionIcon')}>
                      <g xmlns="http://www.w3.org/2000/svg">
                        <path d="M214.8,346.5v-38.2c0-42.4,25.1-80.6,63.8-97.5c20.9-9.1,34.5-29.8,34.5-52.6c0-15.3-6-29.7-16.8-40.5   c-10.8-10.8-25.2-16.8-40.5-16.8c-31.6,0-57.3,25.7-57.3,57.3v24.6h-81.9v-24.6c0-76.8,62.5-139.2,139.2-139.2   c37.2,0,72.1,14.5,98.4,40.8C380.5,86,395,120.9,395,158.1c0,55.4-32.8,105.5-83.6,127.7c-8.9,3.9-14.7,12.7-14.7,22.5v38.2H214.8z   " />
                        <circle cx="255.8" cy="452.9" r="40.9" />
                      </g>
                    </ToolButtonIcon>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
              {displayComponents.fullScreen && (
                <ToolButtonWrapper>
                  <ToolButton
                    selected={document.fullscreenElement}
                    title={getTranslatedKey('fullScreen')}
                    onClick={() => this.fullScreen()}
                    aria-label={getTranslatedKey('print')}>
                    <FullScreenButton selected={document.fullscreenElement} alt={getTranslatedKey('altQuestionIcon')}>
                      {document.fullscreenElement ? (
                        <g>
                          <path d="   M 512.00 180.37   L 512.00 185.74   C 510.02 202.58 497.11 213.32 480.50 213.27   Q 409.21 213.06 337.93 213.04   Q 328.72 213.03 324.23 211.62   C 311.77 207.72 303.13 195.95 303.13 182.66   Q 303.11 109.58 303.12 36.50   C 303.12 25.41 307.41 16.41 316.53 10.11   C 337.11 -4.12 363.38 12.00 363.35 35.99   Q 363.27 94.26 363.32 152.36   A 0.51 0.51 0.0 0 0 363.83 152.87   Q 422.13 152.86 480.50 152.87   C 497.40 152.87 510.17 163.23 512.00 180.37   Z" />
                          <path d="   M 148.65 153.64   Q 148.78 97.36 148.67 40.90   Q 148.65 31.46 150.03 26.74   C 154.11 12.90 168.72 3.08 183.35 5.60   C 198.34 8.18 208.90 20.86 208.88 36.25   Q 208.81 104.77 208.87 173.29   Q 208.88 188.22 207.42 193.07   C 203.69 205.45 191.75 214.09 178.50 214.11   Q 105.25 214.23 32.00 214.27   C 16.31 214.27 3.04 204.33 0.98 188.42   C -0.94 173.53 7.07 159.76 21.81 155.36   Q 26.27 154.02 34.40 154.02   Q 91.33 153.98 148.28 154.01   Q 148.65 154.01 148.65 153.64   Z" />
                          <path d="   M 363.34 358.61   Q 363.25 413.66 363.32 468.70   Q 363.33 481.01 361.82 486.14   C 357.77 499.91 343.26 508.62 328.74 506.40   C 313.51 504.08 303.14 491.83 303.14 476.25   Q 303.16 402.50 303.17 328.75   C 303.17 311.67 315.99 298.01 333.25 297.96   Q 406.75 297.78 480.25 297.84   C 495.40 297.85 506.94 306.49 510.51 320.73   C 514.31 335.89 505.56 351.93 490.68 356.50   Q 485.69 358.03 473.16 358.01   Q 418.54 357.90 363.90 358.05   Q 363.34 358.05 363.34 358.61   Z" />
                          <path d="   M 0.00 331.66   L 0.00 326.17   Q 2.99 305.73 21.26 300.26   Q 25.57 298.97 32.89 298.97   Q 104.00 298.94 175.11 298.97   Q 183.41 298.97 187.75 300.34   C 199.85 304.18 208.63 315.48 208.67 328.50   Q 208.86 399.19 208.83 469.87   Q 208.83 482.10 207.27 486.95   C 199.21 512.10 163.98 513.71 152.06 491.19   Q 148.61 484.67 148.62 476.25   Q 148.69 417.88 148.71 359.60   A 0.47 0.46 0.0 0 0 148.24 359.14   Q 89.76 359.15 31.27 359.13   C 14.54 359.13 1.82 348.54 0.00 331.66   Z" />
                        </g>
                      ) : (
                        <g>
                          <path d="   M 34.02 0.00   L 185.52 0.00   Q 206.38 2.76 215.13 19.59   C 228.00 44.37 210.08 73.14 182.50 73.14   Q 127.94 73.14 73.47 73.14   A 0.32 0.32 0.0 0 0 73.15 73.46   Q 73.17 127.75 73.20 182.00   Q 73.21 196.11 64.70 206.20   C 43.20 231.70 3.20 218.09 0.00 185.38   L 0.00 33.90   C 1.92 15.30 15.37 2.04 34.02 0.00   Z" />
                          <path d="   M 326.74 0.00   L 478.06 0.00   C 496.77 2.09 510.20 15.43 512.00 34.13   L 512.00 185.31   C 508.72 217.27 470.72 231.49 448.35 207.41   Q 438.82 197.15 438.83 182.00   Q 438.86 127.75 438.84 73.57   A 0.42 0.42 0.0 0 0 438.42 73.15   Q 389.13 73.11 339.75 73.16   Q 325.15 73.18 319.85 71.88   C 297.44 66.36 285.93 40.60 296.84 19.66   Q 305.75 2.56 326.74 0.00   Z" />
                          <path d="   M 185.25 512.00   L 33.95 512.00   C 15.23 509.72 2.01 496.92 0.00 477.95   L 0.00 326.41   C 1.80 309.96 13.26 296.30 29.65 293.23   C 52.58 288.94 73.07 306.37 73.10 329.50   Q 73.17 384.00 73.16 438.42   Q 73.16 438.86 73.60 438.86   Q 127.88 438.86 182.25 438.88   C 212.42 438.89 230.49 472.54 212.02 497.37   Q 202.59 510.05 185.25 512.00   Z" />
                          <path d="   M 512.00 326.79   L 512.00 478.00   C 509.60 497.07 496.99 509.90 477.73 512.00   L 326.64 512.00   C 293.93 508.73 280.25 468.90 305.80 447.30   Q 315.71 438.92 329.50 438.91   Q 384.00 438.86 438.40 438.86   A 0.44 0.44 0.0 0 0 438.84 438.42   Q 438.84 384.00 438.84 329.50   C 438.84 300.97 469.59 283.09 494.31 297.92   Q 509.72 307.17 512.00 326.79   Z" />
                        </g>
                      )}
                    </FullScreenButton>
                  </ToolButton>
                </ToolButtonWrapper>
              )}
            </ToolButtonsContainer>
            {this.hasButtons() && (
              <MoreButton
                title={getTranslatedKey('moreOpts')}
                id="more-button"
                onClick={() => this.onClickMoreBtn()}
                aria-label={getTranslatedKey('aria_opcionsBtn')}>
                <MoreButtonIcon alt={getTranslatedKey('altMoreIcon')} id="More" enable-background="new 0 0 32 32" viewBox="0 0 32 32">
                  <path xmlns="http://www.w3.org/2000/svg" id="XMLID_294_" d="m13 16c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                  <path xmlns="http://www.w3.org/2000/svg" id="XMLID_295_" d="m13 26c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                  <path xmlns="http://www.w3.org/2000/svg" id="XMLID_297_" d="m13 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                </MoreButtonIcon>
              </MoreButton>
            )}
          </NavContainer>
        </Nav>
        {displayComponents.cerca && (
          <CollapsedNav>
            {displayComponents.infoCerca && (
              <InfoButton onClick={() => this.toggleShare('info')}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" width="20" fill="#666666" viewBox="0 0 512 512">
                  <g>
                    <g>
                      <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256    C512,114.511,397.504,0,256,0z M282.289,357.621c0,8.088-11.794,16.174-26.284,16.174c-15.164,0-25.946-8.086-25.946-16.174    V229.234c0-9.435,10.783-15.839,25.946-15.839c14.49,0,26.284,6.404,26.284,15.839V357.621z M256.006,182.396    c-15.501,0-27.631-11.457-27.631-24.263c0-12.805,12.131-23.925,27.631-23.925c15.164,0,27.296,11.12,27.296,23.925    C283.302,170.939,271.169,182.396,256.006,182.396z" />
                    </g>
                  </g>
                </svg>
              </InfoButton>
            )}
            <SearcherWrapper className="input-group">
              <GraySearchButton title={getTranslatedKey('cerca')} onClick={() => this.onBusquedaBtnClick()}>
                <FaSearch
                  style={{
                    verticalAlign: 'middle',
                    transform: 'translate(0px, -2px)'
                  }}
                />
              </GraySearchButton>
              <SearcherInput
                type="text"
                className="form-control"
                aria-describedby="basic-addon1"
                placeholder={getTranslatedKey('cercaPlaceholder')}
                onChange={(e) => this.handleSearch(e)}
                onKeyDown={(e) => this.onBusquedaKeyDown(e)}
                id="inputCercaCollapsed"
                value={this.state.searchText}
                title={getTranslatedKey('cerca')}
                fontSizeEnabled={this.props.fontSizeEnabled}
              />
              {this.state.searchText.length > 0 && (
                <DeleteSearchIconButton title={getTranslatedKey('esborra')} onClick={() => this.onDeleteSearchBtnClick()}>
                  <DeleteSearchIcon alt={getTranslatedKey('altDeleteIcon')} title={getTranslatedKey('esborrarCerca')}>
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                    />
                  </DeleteSearchIcon>
                </DeleteSearchIconButton>
              )}
            </SearcherWrapper>
            {displayComponents.cercaAvançada && (
              <TreeSearchButtonWrapper navHeight={this.props.navHeight}>
                <TreeSearchButton
                  id="CercaBtn"
                  selected={this.props.cercaAvançada}
                  onClick={() => this.onCercaAvançadaBtnClick()}
                  title={getTranslatedKey('cercaAvançada')}>
                  <SvgSearchButton version="1.1" width="24" height="24" viewBox="0 0 24 24" selected={this.props.cercaAvançada}>
                    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                  </SvgSearchButton>
                </TreeSearchButton>
              </TreeSearchButtonWrapper>
            )}
          </CollapsedNav>
        )}
        {this.state.modalAjudaOpen && displayComponents.ajuda && (
          <AjudaModal fontSizeEnabled={this.props.fontSizeEnabled}>
            {displayComponents.ajuda && <AjudaModalText onClick={() => this.onQuestionBtnClick()}>{getTranslatedKey('help')}</AjudaModalText>}
            {displayComponents.manual && (
              <AjudaModalText onClick={() => this.handleGuia()}>
                {getTranslatedKey('guiaUs')}
                <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                  <g>
                    <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                    <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                  </g>
                </SVGNewTab>
              </AjudaModalText>
            )}
            {displayComponents.faqs && (
              <AjudaModalText onClick={() => this.handleFaqs()}>
                {getTranslatedKey('faqs')}
                <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                  <g>
                    <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                    <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                  </g>
                </SVGNewTab>
              </AjudaModalText>
            )}
            {displayComponents.tutorial && (
              <AjudaModalText onClick={() => this.handleTutorial()}>
                {getTranslatedKey('tutorial')}
                <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                  <g>
                    <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                    <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                  </g>
                </SVGNewTab>
              </AjudaModalText>
            )}
          </AjudaModal>
        )}

        <ModalAccesibilityContainer id="modal-accesibilidad" open={this.state.toolAccesibilityBtn} fontSizeEnabled={this.props.fontSizeEnabled}>
          <ModalAccesibilityForm>
            <AccesibilityTitleLabel>{getTranslatedKey('accesibility')}</AccesibilityTitleLabel>
            <TamanyLletraLabel fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('mida')}</TamanyLletraLabel>
            <AccesibilityRow>
              <AccesibilityFontSize>
                <Switch>
                  <SwitchCB type="checkbox" check={this.props.fontSizeEnabled} onClick={() => this.onAccesibilitySliderClick('lletra')}></SwitchCB>
                  <SwitchSpan></SwitchSpan>
                </Switch>
              </AccesibilityFontSize>
              <FormIcon src={this.props.navbarObj.fontSizeIcon} alt={getTranslatedKey('fontSizeAlt')} />
            </AccesibilityRow>
          </ModalAccesibilityForm>
        </ModalAccesibilityContainer>
        <ToolButtonsCollapsedContainer
          open={this.state.toolCollapsedContainer}
          id="modal-tool-buttons-collapsed"
          fontSizeEnabled={this.props.fontSizeEnabled}>
          <ToolButtonsCollapsedWrapper>
            <TBCul>
              {displayComponents.descarrega && (
                <TBCli>
                  <TBCbtn onClick={() => this.toggleShare('download')} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {this.props.user?.user && this.props.intranet ? getTranslatedKey('gestion') : getTranslatedKey('titleNoUser')}
                  </TBCbtn>
                </TBCli>
              )}
              {displayComponents.imprimir && (
                <TBCli>
                  <TBCbtn fontSizeEnabled={this.props.fontSizeEnabled} onClick={() => this.toggleShare('print')}>
                    {getTranslatedKey('printText')}
                  </TBCbtn>
                </TBCli>
              )}
              {displayComponents.compartir && (
                <>
                  <TBCli>
                    <TBCbtn fontSizeEnabled={this.props.fontSizeEnabled} onClick={() => this.toggleShare('share')}>
                      {getTranslatedKey('share')}
                    </TBCbtn>
                  </TBCli>
                </>
              )}
              {displayComponents.accessibilitat && (
                <TBCli>
                  <TBCbtn
                    open={this.state.toolAccesibilityBtn}
                    onClick={() => this.onAccesibilityBtnClick()}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('accesibility')}
                  </TBCbtn>
                </TBCli>
              )}
              {displayComponents.contact && (
                <TBCli>
                  <TBCbtn fontSizeEnabled={this.props.fontSizeEnabled}>
                    <TBCa href={visorVariables.correuSuggeriment} rel="noreferrer" target="_blank">
                      {getTranslatedKey('comments')}
                    </TBCa>
                  </TBCbtn>
                </TBCli>
              )}
              {displayComponents.ajuda && (
                <TBCli>
                  <TBCbtn onClick={() => this.toggleModalAjuda()} fontSizeEnabled={this.props.fontSizeEnabled}>
                    <TBCa rel="noreferrer" target="_blank">
                      {getTranslatedKey('help')}
                    </TBCa>
                  </TBCbtn>
                </TBCli>
              )}
              {displayComponents.fullScreen && (
                <TBCli>
                  <TBCbtn open={document.fullscreenElement} onClick={() => this.fullScreen()} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('fullScreenRes')}
                  </TBCbtn>
                </TBCli>
              )}
            </TBCul>
          </ToolButtonsCollapsedWrapper>
        </ToolButtonsCollapsedContainer>
      </>
    );
  }
}

export default Navbar;
